import { RobotDevice } from '../types';
import { RobotConnectionListeners } from './types';

/**
 * Add connection listeners to the provided robot connection.
 * It is safe for the connection to be undefined.
 */
export const addConnectionListeners = (
  device: RobotDevice,
  connListeners: RobotConnectionListeners
) => {
  Object.entries(connListeners).forEach(([eventName, eventCallback]) => {
    device?.websocketConnection?.socket?.on(
      eventName as keyof RobotConnectionListeners,
      eventCallback
    );
  });
};

/**
 * Remove connection listeners to the provided robot connection.
 * It is safe for the connection to be undefined.
 */
export const removeConnectionListeners = (
  device: RobotDevice,
  connListeners: RobotConnectionListeners
) => {
  Object.entries(connListeners).forEach(([eventName, eventCallback]) => {
    device?.websocketConnection?.socket?.off(
      eventName as keyof RobotConnectionListeners,
      eventCallback
    );
  });
};
